import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    loading: false,
    error: '',
    errorData: null,
    message: '',
    info: '',
    timeLeft: 60,
    isRunning: false,
    unreadNotifications: [],
    isPushNotificationSupported: false
}

export const generalSlice = createSlice({
    name: "general",
    initialState,
    reducers: {
        setAppLoading: (state, action) => {
            state.loading = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        setErrorData: (state, action) => {
            state.errorData = action.payload
        },
        setMessage: (state, action) => {
            state.message = action.payload
        },
        setInfo: (state, action) => {
            state.info = action.payload
        },
        startTimer: (state) => {
            state.isRunning = true;
        },
        stopTimer: (state) => {
            state.isRunning = false;
        },
        resetTimer: (state, action) => {
            state.timeLeft = action.payload; // Reset to initial or specified value
            state.isRunning = false;
        },
        decrementTimer: (state) => {
            if (state.timeLeft > 0) {
                state.timeLeft -= 1;
            } else {
                state.isRunning = false; // Stop the timer when it reaches zero
            }
        },
        incrementUnreadNotificationsCount: (state, action) => {
            state.unreadNotifications = Array.isArray(state.unreadNotifications)
            ? [...state.unreadNotifications, action.payload]
            : [action.payload];
            // state?.unreadNotifications = [...state.unreadNotifications, action.payload]
        },
        decrementUnreadNotificationsCount: (state, action) => {
            const result = state.unreadNotifications.filter(
                e => e.notificationId !== action.payload?.notificationId //notification id
            )
            state.unreadNotifications = result
        },
        resetUnreadNotificationCount: (state) => {
            state.unreadNotifications = []
        },
        setIsPushNotificationSupported: (state, action) => {
            state.isPushNotificationSupported = action.payload
        }
    }
})

export const {
    setAppLoading,
    setError,
    setMessage,
    setErrorData,
    startTimer,
    stopTimer,
    resetTimer,
    decrementTimer,
    setInfo,
    resetUnreadNotificationCount,
    incrementUnreadNotificationsCount,
    decrementUnreadNotificationsCount,
    setIsPushNotificationSupported
} = generalSlice.actions
export default generalSlice.reducer